import { IonContent } from "@ionic/react";

import { BackToolbarComponent } from "@/components/toolbar/back-toolbar";
import { useSafeAreaStyles } from "@/hooks/utils/use-safe-area-styles";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { IonPage } from "@ionic/react";
import { forwardRef, ReactNode } from "react";

interface PageContainerProps {
  children: ReactNode;
  className?: string;
  showToolbar?: boolean;
  showLogo?: boolean;
  bgColor?: string;
  headerBgColor?: string;
  contentBgColor?: string;
  onBack?: () => void;
  title?: string;
  titleFontSize?: keyof typeof textVariants;
  subtitle?: string;
  actionButton?: React.ReactNode;
  fullScreen?: boolean;
}

export const PageContainer = forwardRef<HTMLElement, PageContainerProps>(function PageContainer(
  {
    children,
    className,
    showToolbar = true,
    showLogo = false,
    bgColor = "white",
    headerBgColor = "white",
    contentBgColor = "white",
    onBack,
    title,
    titleFontSize = "title1",
    subtitle,
    actionButton,
    fullScreen = true,
  },
  ref,
) {
  const safeAreaStyles = useSafeAreaStyles();
  return (
    <IonPage ref={ref} color={bgColor ?? "white"} style={{ ...safeAreaStyles }}>
      {showToolbar && (
        <BackToolbarComponent
          onBack={onBack}
          showLogo={showLogo}
          title={title}
          titleFontSize={titleFontSize}
          subtitle={subtitle}
          bgColor={headerBgColor}
          actionButton={actionButton}
        />
      )}
      <IonContent fullscreen={fullScreen} color={contentBgColor}>
        <div
          className={cn(
            "mx-auto flex h-full w-full max-w-[450px] flex-col items-center justify-start gap-4 overflow-hidden",
            className,
          )}
        >
          {children}
        </div>
      </IonContent>
    </IonPage>
  );
});
